import { Component } from '@angular/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { MetaService } from 'src/app/Services/meta-data.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';

@Component({
  selector: 'app-not-available',
  templateUrl: './not-available.component.html',
  styleUrls: ['./not-available.component.scss'],
})
export class NotAvailableComponent {
  lang: any;
  environmentVariables: any;
  constructor(
    public embryoService: EmbryoService,
    private metaService: MetaService,
    private confgServ: StaticPagesService
  ) {
    this.confgServ.getenvConfig().subscribe((res) => {
      this.environmentVariables = res;
    });
    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
      if (this.lang == 'en')
        this.metaService.setTitle(
          `Not Available - ${this.environmentVariables.APP_NAME}`
        );
      else
        this.metaService.setTitle(
          `غير متاحه - ${this.environmentVariables.APP_NAME_AR}`
        );
    });
  }
}
